import { render } from "./BrandForm.vue?vue&type=template&id=36295d4a&scoped=true&ts=true"
import script from "./BrandForm.vue?vue&type=script&lang=ts"
export * from "./BrandForm.vue?vue&type=script&lang=ts"

import "./BrandForm.vue?vue&type=style&index=0&id=36295d4a&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36295d4a"]])

export default __exports__